const getTrackingSummaryContentStyles = theme => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  marginTop: theme.spacing(),
  [theme.mediaQuery('tablet')]: {
    flexDirection: 'row',
    alignItems: 'center'
  }
});
const getTrackingSummaryStatusStyles = () => ({
  flex: '1 1 auto'
});
const getTrackingSummaryDeliveryStyles = theme => ({
  flex: '0 0 auto',
  marginTop: theme.spacing(2),
  [theme.mediaQuery('tablet')]: {
    marginTop: 0,
    marginLeft: theme.spacing(3),
    textAlign: 'right'
  }
});
const getContactLinkWrapperStyles = theme => ({
  display: 'inline-flex',
  marginTop: theme.spacing(2),
  flex: '0 0 auto',
  width: '100%',
  [theme.mediaQuery('tablet')]: {
    width: '100%',
    justifyContent: 'end',
    flex: `0 0 ${theme.spacing(25)}px`,
    marginTop: 0,
    marginLeft: theme.spacing(7)
  }
});

export { getContactLinkWrapperStyles, getTrackingSummaryContentStyles, getTrackingSummaryDeliveryStyles, getTrackingSummaryStatusStyles };
//# sourceMappingURL=TrackingSummaryStyles.js.map
